module.exports = __webpack_public_path__ + "static/oec_hardware.4a5da036.png";